import styled from 'styled-components'

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  width: 100%;
  aspect-ratio: 1 / 0.5;
  gap: 5px;
  border-radius: 16px;
  overflow: hidden;

  @media (max-width: 768px) {
    aspect-ratio: 1 / 1.1;
    display: flex;
    flex-direction: column-reverse;
  }
`

export const TopRow = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  width: 100%;
  height: 100%;
  gap: 5px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
  }
`

export const BottomRow = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  gap: 5px;
`

export const Image = styled.div<{ image: string }>`
  background-image: url('${({ image }) => image}');
  background-position: center;
  max-width: 100%;
  width: 100%;
  background-size: cover;
  height: auto;
  box-sizing: border-box;
  overflow: hidden;
`
